import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  ChangeDetectorRef,
  AfterViewInit,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Customer } from '../interfaces/customer.model';
import * as moment from 'moment';
import icClose from '@iconify/icons-ic/twotone-close';
import icPrint from '@iconify/icons-ic/twotone-print';
import icDownload from '@iconify/icons-ic/twotone-cloud-download';
import icDelete from '@iconify/icons-ic/twotone-delete';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icPerson from '@iconify/icons-ic/twotone-person';
import icMyLocation from '@iconify/icons-ic/twotone-my-location';
import icLocationCity from '@iconify/icons-ic/twotone-location-city';
import icEditLocation from '@iconify/icons-ic/twotone-edit-location';
import icDescription from '@iconify/icons-ic/twotone-description';
import { Observable } from 'rxjs';
import icVerticalSplit from '@iconify/icons-ic/twotone-vertical-split';
import icVisiblity from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import icDoneAll from '@iconify/icons-ic/twotone-done-all';
import icMoreVert from '@iconify/icons-ic/twotone-more-vert';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { startWith, map, timeout, filter, count } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { ThemePalette } from '@angular/material/core';
import { fadeInUp400ms } from '../../../../../../@vex/animations/fade-in-up.animation';
import { stagger40ms } from '../../../../../../@vex/animations/stagger.animation';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
  MatFormField,
} from '@angular/material/form-field';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JobsService } from '../../../../../../@vex/services/jobsService/jobs.service';
import { DepartmentService } from '../../../../../../@vex/services/departmentService/department.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of } from 'rxjs';
import { ValidatorFn } from '@angular/forms';
import { fadeInRight400ms } from 'src/@vex/animations/fade-in-right.animation';
import { scaleIn400ms } from 'src/@vex/animations/scale-in.animation';
import { AddNewQuestionComponent } from './add-new-question/add-new-question.component';
import { BackgroundService } from 'src/@vex/services/background.service';
import { Router } from '@angular/router';
import { JobListCreateUpdateComponent } from '../../../settings/recruiting-preference/custom-field/job-list/job-list-create-update/job-list-create-update.component';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { AppErrorStateMatcher } from 'src/app/shared/app-error-state-matcher';
import { CompanyInfoService } from 'src/@vex/services/companySettingService/companyInfo';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TranslateService } from '@ngx-translate/core';
import { validateBasis } from '@angular/flex-layout';
import { EnvironmentService } from 'src/app/services/environment.service';
import { UserPreferenceService } from 'src/app/services/user-preference.service';
import { BaseComponent, SnackBarDuration } from 'src/app/components/base/base.component';
import { PreferenceKeys } from 'src/app/interfaces/preference-keys.enum';

declare global {
  interface Window {
    allRecruiters: any;
    allHiringManager: any;
    buisnessUnitData: any;
    jobKeywordData: any;
    resourcesData: any;
    jobQuestionsData: any;
    allJobKeywords: any;
  }
}

@UntilDestroy()
@Component({
  selector: 'vex-job-create-update',
  templateUrl: './job-create-update.component.html',
  styleUrls: [
    './job-create-update.component.scss',
    '../../../../../../../node_modules/quill/dist/quill.snow.css',
    '../../../../../../@vex/styles/partials/plugins/_quill.scss',
  ],

  encapsulation: ViewEncapsulation.None,
  animations: [fadeInUp400ms, stagger40ms],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
      } as MatFormFieldDefaultOptions,
    },
  ],
})
export class JobCreateUpdateComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  public keyFormGroup: FormGroup;

  /** 2. Location */
  public locationFormGroup: FormGroup;

  public dateFormGroup: FormGroup;
  public salaryFormGroup: FormGroup;
  public optionalFormGroup: FormGroup;
  public customFormGroup = new FormGroup({});
  public userFormGroup: FormGroup;
  public questionFormGroup: FormGroup = new FormGroup({}); // never used the form
  public sectionForms: FormGroup;
  public resourceFormGroup: FormGroup;
  public scorecardFormGroup: FormGroup;
  public templateFormGroup: FormGroup;
  public IsCheckedTandC: boolean;

  jobTemplates: any = [];
  filteredTemplates: Observable<any[]>;
  templateInputCtrl = new FormControl('');

  public yearOfExperienceData: any = [];

  /** 7. Questions */
  jobQuestionGroups: any = [];

  jobtypeData: any = [];
  eeoJobcategoryData: any = [];
  shiftData: any = [];
  languageData: any = [];
  joblevelData: any = [];
  educationLevelData: any = [];
  jobDurationData: any = [];
  jobTravelFrequencyData: any = [];
  jobExpirationDateData: any = [];

  freeSalaryTypes = ['0', 'H', 'Y'];
  salTypeData: any = [];
  salarySetError: boolean = false;
  jobCategoryData: any = [];
  jobSubCategoryData: any = [];
  jobCostCenterData: any = [];
  jobCurrencyData: any = [];
  jobAvailableScorecardData: any = [];

  customFields: any = [];

  passwordInputType = 'password';
  showJobDescriptionError = true;
  loginUserData;

  static id = 100;
  form: FormGroup;
  mode: 'create' | 'update' = 'create';

  buisnessUnitData: any = [];
  departmentData: any = [];

  recruitersData: any = [];
  powerUserData: any = [];
  firstnamedata: any = [];
  icMoreVert = icMoreVert;

  icClose = icClose;
  recruiterNames: any = [];
  icDoneAll = icDoneAll;
  icDescription = icDescription;
  icVerticalSplit = icVerticalSplit;
  icVisibility = icVisiblity;
  icVisibilityOff = icVisibilityOff;
  icPrint = icPrint;
  icDownload = icDownload;
  icDelete = icDelete;
  icPerson = icPerson;
  icMyLocation = icMyLocation;
  icLocationCity = icLocationCity;
  icEditLocation = icEditLocation;
  icPhone = icPhone;

  // resourcesData = ELEMENT_RESOURCES_DATA;

  minDate: Date = new Date();
  countriesData: any = [];
  filteredCountriesData: Observable<any[]>;
  stateData: any = [];
  filteredStateData: Observable<any[]>;
  companyData;
  canada;
  uk;
  us;
  // job keyword variable
  JKvisible = true;
  JKselectable = true;
  JKremovable = true;
  JKseparatorKeysCodes: number[] = [ENTER, COMMA];
  JKeywordCtrl = new FormControl();
  JKeywords: Observable<string[]>;
  keywords: string[] = [];
  allJobKeywords: string[] = [];

  @ViewChild('keywordInput') keywordInput: ElementRef<HTMLInputElement>;
  @ViewChild('autoKeyword') keywordMatAutocomplete: MatAutocomplete;
  @ViewChild('horizontalStepper') stepper: MatHorizontalStepper;

  // Hiring Manager
  visible = true;
  selectable = true;
  removable = true;

  separatorKeysCodes: number[] = [ENTER, COMMA];

  allHiringManagers: any = []; // all hiring managers
  selectedHiringMangers: any = []; // currently selected hiring managers

  // An abserver that listen to the input controls and contains the filtered list for autocomplete list
  filteredHiringManagers: Observable<any>;

  // hiringManagerData: any = [];

  // hiringManagerOptions: Observable<any>;
  // hiringManager: string[] = [];
  // allHiringManager: string[] = [];

  @ViewChild('hiringManagerInput')
  hiringManagerInput: ElementRef<HTMLInputElement>;

  // recruiters
  visible2 = true;
  selectable2 = true;
  removable2 = true;

  separatorKeysCodes2: number[] = [ENTER, COMMA];

  allRecruiters: any = [];
  selectedRecruiters: any = [];

  filteredRecruiters: Observable<any>;

  @ViewChild('recruiterInput') recruiterInput: ElementRef<HTMLInputElement>;

  allComplete: boolean = false;
  jobConfidentialData;
  jobKeywordData;
  Checkedval = '';

  forms: FormGroup;

  matcher = new AppErrorStateMatcher();

  keyword: any = [];

  // resource step var declarations
  resourcesData: any = [];

  isSimpleCreationEnabled: boolean = false;
  isPremiumUser: boolean = false;
  simpleCreationCtrl: FormControl;

  @ViewChildren(MatFormField) formFields: QueryList<MatFormField>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public defaults: any,
    private router: Router,
    private dialogRef: MatDialogRef<JobCreateUpdateComponent>,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private _jobService: JobsService,
    private _departmentService: DepartmentService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private _backgroundService: BackgroundService,
    public translate: TranslateService,
    private _companyInfoService: CompanyInfoService,
    private envService: EnvironmentService,
    private preferenceService: UserPreferenceService
  ) {
    super(snackBar, translate);

    /** Location Form */
    this.locationFormGroup = this.fb.group({
      locations: [''],
      locationCity: ['', Validators.required],
      locationCountry: ['', Validators.required],
      locationState: ['', Validators.required],
      locationZip: ['', Validators.required],
      locationAdditional: [''],
    });

    const salaryType = this.isHourlyApplyAvailable() ? 'H' : '0';

    this.salaryFormGroup = this.fb.group({
      salary: '1',
      min: [, Validators.required],
      max: [, [salaryValidator()]],
      currency: [, Validators.required],
      type: [salaryType, Validators.required],
    });

    this.customFormGroup = this.fb.group({});

    this.resourceFormGroup = this.fb.group({
      // resources: new FormArray([], minSelectedCheckboxes(1))
      resources: new FormArray([]),
    });
  }

  ngOnInit() {
    const membership$ = +localStorage.getItem('membership');

    /**
     * load configuration based on membership
     * configuration is always preferred
     * 1. free users: default true
     * 2. paid users: default false
     */
    if (membership$ > 0) {
      this.isPremiumUser = true;
      // load the configuration
      const simpleJobCreationEnabled$ =
        this.envService.getConfig('simpleJobCreationEnabled').paid ?? false;

      // check for user preference
      const preference = JSON.parse(localStorage.getItem('userPreference'));
      if (preference.custom) {
        // user preference or configuration
        this.isSimpleCreationEnabled =
          preference.custom.simpleJobCreationEnabled ?? simpleJobCreationEnabled$;
      }

      this.simpleCreationCtrl = new FormControl(this.isSimpleCreationEnabled);
    } else {
      // simple job creation default 'true' for free users
      // load the configuration
      this.isSimpleCreationEnabled =
        this.envService.getConfig('simpleJobCreationEnabled').free ?? true;
    }
    // this.getCompanyInfo();

    this.loginUserData = JSON.parse(localStorage.getItem('UserInfo'));

    if (this.defaults) {
      this.mode = 'update';
      this.keyword =
        this.defaults.jobkeyword != '' ? this.defaults.jobkeyword.split(',') : [];
      this.keywords = this.keyword;
    } else {
      this.defaults = {} as Customer;
    }

    this.filteredTemplates = this.templateInputCtrl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const title = typeof value === 'string' ? value : value?.TemplateTitle;
        return title ? this.filterTemplates(title as string) : this.jobTemplates.slice();
      })
    );

    this.keyFormGroup = this.fb.group({
      jobTitle: [
        this.defaults.jobtitle ? this.defaults.jobtitle : null,
        Validators.required,
      ],
      jobKeyword: [this.defaults.jobkeyword ? this.defaults.jobkeyword : null],
      buisnessUnit: [this.defaults.BUID ? this.defaults.BUID : null, Validators.required],
      department: [
        this.defaults.department ? this.defaults.department : null,
        Validators.required,
      ],
      // keyCountry: [null, Validators.required],
      // keyState: [null, Validators.required],
      jobDescription: ['', Validators.required],
      // requiredSkillExperience: [this.defaults.RequiredExperience ? this.defaults.RequiredExperience : ""],
      jobBenefit: [this.defaults.jobbenefit ? this.defaults.jobbenefit : ''],
    });

    this.keyFormGroup.controls.jobDescription.valueChanges.subscribe(data => {
      this.showJobDescriptionError =
        !data || data.replace('<p>').replace('</p>').length == 0;
    });

    if (this.defaults.jobdescription) {
      this.keyFormGroup.controls.jobDescription.setValue(this.defaults.jobdescription);
    }

    // this.locationFormGroup = this.fb.group({
    //   locationCity: [this.defaults.jobcity ? this.defaults.jobcity : null, Validators.required],
    //   locationCountry: ['', Validators.required],
    //   locationState: ['', Validators.required],
    //   locationZip: [this.defaults.zip ? this.defaults.zip : null, Validators.required],
    //   locationAdditional: [this.defaults.JobLocationstr ? this.defaults.JobLocationstr : null],
    // });

    this.locationFormGroup.controls['locationCountry'].valueChanges.subscribe(value => {
      // this will be only run when countries are available
      // rest will be ensured in after getting countries
      if (this.countriesData.length > 0) {
        if (value && value.trim().length > 0) {
          this.filteredCountriesData = this.countriesData.filter(option =>
            option.name.toLowerCase().includes(value.toLowerCase())
          );

          const foundCountry = this.countriesData.find(
            country => country.name.toLowerCase() == value.toLowerCase()
          );
          if (foundCountry) {
            this.getStates(foundCountry.name);
          } else {
            this.locationFormGroup.controls.locationCountry?.setValue('');

            // must clear states when the country is reset
            this.stateData = [];
            this.locationFormGroup.controls.locationState?.setValue('');
          }
        } else {
          this.filteredCountriesData = this.countriesData.slice();
        }
      }
    });

    this.locationFormGroup.controls['locationState'].valueChanges.subscribe(value => {
      this.filteredStateData = this.stateData.filter(state =>
        state.name.toLowerCase().includes(value.toLowerCase())
      );
    });

    let locations = [];
    if (this.defaults.locations) {
      locations = this.defaults.locations.map(item => item.deptid);
    }

    // not recreate the form, just patch values
    // ! can't set the default directly as we are getting iso codes for the job country and state
    this.locationFormGroup.patchValue({
      locations: locations,
      locationCity: this.defaults.jobcity ?? '',
      locationCountry: '',
      locationState: '',
      locationZip: this.defaults.zip ?? '',
      locationAdditional: this.defaults.JobLocationstr ?? '',
    });

    const internal =
      this.defaults.expiredate && this.defaults.postingdate
        ? `${Math.round(
            (new Date(this.defaults.expiredate).getTime() -
              new Date(this.defaults.postingdate).getTime()) /
              (30 * 24 * 60 * 60 * 1000)
          )}m`
        : null;
    // this.dateFormGroup = this.fb.group({
    //   internalCarrerHosting: [internal == "12m" ? "1y" : internal, Validators.required],
    //   chooseDate: [null],
    //   startingDate: [this.defaults.startdate ? new Date(this.defaults.startdate) : new Date()],
    // });

    const isHourlyApplyAvailable: boolean = this.isHourlyApplyAvailable();
    const defaultSalaryMin = isHourlyApplyAvailable ? 50 : 50000;
    const defaultSalaryMax = isHourlyApplyAvailable ? 100 : 60000;
    const salaryType = isHourlyApplyAvailable ? 'H' : '0';

    this.salaryFormGroup.patchValue({
      min: this.defaults.salary
        ? parseInt(this.defaults.salary.replace(/[^\d.-]/g, ''))
        : defaultSalaryMin,
      max: this.defaults.salaryrange
        ? parseInt(this.defaults.salaryrange.replace(/[^\d.-]/g, ''))
        : defaultSalaryMax,
      currency: this.defaults.jobcurrency ? this.defaults.jobcurrency : 'USD',
      type:
        this.defaults.salarytype &&
        this.freeSalaryTypes.includes(this.defaults.salaryType)
          ? this.defaults.salarytype
          : salaryType,
    });

    this.optionalFormGroup = this.fb.group({
      jobCateogary: [this.defaults.jobcatid ? this.defaults.jobcatid : ''],
      subCategory: [this.defaults.jobsub_id ? this.defaults.jobsub_id : ''],
      eeoJobCateogray: [this.defaults.eeoc_job_cat ? this.defaults.eeoc_job_cat : ''],
      status: [
        this.defaults.status ? `${this.defaults.status}` : '1',
        Validators.required,
      ],
      startingDate: [this.defaults.startdate ? new Date(this.defaults.startdate) : new Date()],
      language: [this.defaults.joblanguage ? Number(this.defaults.joblanguage) : 668],
      jobLevel: [
        this.defaults.joblevel ? Number(this.defaults.joblevel) : this.defaults.joblevel,
      ],
      customJobId: [this.defaults.trackingcode ? this.defaults.trackingcode : ''],
      noOfOpening: [
        this.defaults.numopening ? this.defaults.numopening : 1,
        Validators.required,
      ],
      yearOfExperience: [this.defaults.expyears ? this.defaults.expyears : ''],
      levelOfEducation: [this.defaults.degree ? Number(this.defaults.degree) : ''],
      jobDuration: [this.defaults.jobduration ? this.defaults.jobduration : ''],
      travelFrequence: [
        this.defaults.travel && `${this.defaults.travel}`.length == 1
          ? `00${this.defaults.travel}`
          : `${this.defaults.travel}`.length == 2
          ? `0${this.defaults.travel}`
          : '0',
      ],
      internalCommentNotes: [this.defaults.IntNotes ? this.defaults.IntNotes : ''],
      jobType: [
        this.defaults.jobtype ? this.defaults.jobtype : 'Full Time',
        Validators.required,
      ],
      jobConfidential: [
        this.defaults.JobTotalconfidential
          ? `${this.defaults.JobTotalconfidential}`
          : '0',
      ],
      jobPriority: [this.defaults.priority ? `${this.defaults.priority}` : '1'],
    });

    this.userFormGroup = this.fb.group({
      hiringManager: [null],
      // recruiter: [null],
      owner: [
        this.defaults.jobownerID ? this.defaults.jobownerID : this.loginUserData.uid,
        Validators.required,
      ],
    });

    this.sectionForms = this.fb.group({
      sectionForm: this.fb.array([]),
    });

    this.scorecardFormGroup = this.fb.group({
      scorecard: [this.defaults.SGID ? this.defaults.SGID : null],
    });

    this.templateFormGroup = this.fb.group({
      templateTitle: [''],
    });

    this.optionalFormGroup.controls.jobConfidential.setValue('0');

    this._jobService.getJobKeyword().subscribe(data => {
      const keywords: any = data;

      // taking out empties
      const filtered = keywords.filter(
        existing => existing.HotbookName && existing.HotbookName.trim().length > 0
      );
      this.jobKeywordData = filtered;
      window.allJobKeywords = this.jobKeywordData;
      if (window.allJobKeywords) {
        this.JKeywords = this.keyFormGroup.controls.jobKeyword.valueChanges.pipe(
          startWith(null),
          map((fruit: string | null) =>
            fruit ? this._filterKeyword(fruit) : window.allJobKeywords.slice()
          )
        );
      }
    });

    this._jobService.getHiringManagersData().subscribe(response => {
      let hiringManagers: any = response;
      hiringManagers.forEach(hiringManager => {
        this.allHiringManagers.push(hiringManager);
      });

      if (this.defaults.hmjobs) {
        this.defaults.hmjobs.map(selectedHiringManager => {
          const selected = this.allHiringManagers.find(
            hiringManager => hiringManager.uid == selectedHiringManager.recruiter_id
          );
          if (selected) {
            this.selectedHiringMangers.push(selected);
          }
        });
      }

      this.filteredHiringManagers =
        this.userFormGroup.controls.hiringManager.valueChanges.pipe(
          startWith(null),
          map((value: any | null) => {
            return value && typeof value == 'string'
              ? this.filterHiringManagers(value)
              : this.allHiringManagers.slice();
          })
        );
    });

    // Commnted by Cai on 25 Feb, 2023
    // this._jobService.getRecruitersData().subscribe((response) => {
    //   let recruiters: any = response;
    //   recruiters.forEach(recruiter => this.allRecruiters.push(recruiter));

    //   if (this.defaults.rtjobs) {
    //     this.defaults.rtjobs.map(selectedRecruiter => {
    //       const selected = this.allRecruiters.find(recruiter => recruiter.uid == selectedRecruiter.recruiter_id);
    //       if (selected) {
    //         this.selectedRecruiters.push(selected);
    //       }
    //     });
    //   }

    //   this.filteredRecruiters = this.userFormGroup.controls.recruiter.valueChanges.pipe(
    //     startWith(null),
    //     map((value: any | null) => {
    //       return (value && typeof(value) == 'string') ? this.filterRecruiters(value) : this.allRecruiters.slice();
    //     })
    //   );
    // });

    /** Key */
    this.getJobTemplates();

    this.getJobKeywordData();
    this.getBusinessUnits();
    if (this.defaults.BUID) {
      this.getDepartments(this.defaults.BUID);
    }

    /** 2. Location */
    this.getCountries();

    /** Date */
    this.getJobExpirationDateData();

    /** 3. Salary */
    this.getJobCurrencyData();
    this.getSalTypeData();

    /** 4. Optional */
    this.getCateogires();
    this.getEEOJobCategoryData();
    this.getJobTypeData();
    this.getShiftData();
    this.getJobConfidentialData();
    this.getLanaguageData();
    this.getJobLevelData();
    this.getYearOfExperienceData();
    this.getEducationLevelData();
    this.getJobDurationData();
    this.getJobTravelFrequencyData();

    /** 5. Custom Fields */
    this.getCustomFields();

    /** 6. Users */
    // hiring managers
    // recruiters
    this.getPowerUsersData();

    /** 7. Questions */
    this.getPrescreenQuestions();

    /** 8. Resources */
    this.getResourcesData();

    /** 9. Scorecard */
    this.getAvailableScorecardData();

    /** 10. Save as tempalte */

    // no used
    // this.getCostCenterData();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.formFields.forEach(ff => {
        ff.updateOutlineGap();
      });
    }, 200);
  }

  onSimpleCreationToggleChanged($event) {
    const simpleCreationEnabled$ = $event.checked;
    this.isSimpleCreationEnabled = simpleCreationEnabled$;

    let preference = JSON.parse(localStorage.getItem('userPreference'));

    if (Array.isArray(preference.custom)) {
      // This is designed to avoid any unexpected issues from the previous save
      // force update with key/value format
      preference.custom = {
        simpleJobCreationEnabled: simpleCreationEnabled$,
      };
    } else {
      // Just add a new key value
      preference.custom.simpleJobCreationEnabled = simpleCreationEnabled$;
    }

    // update the local preferencne
    localStorage.setItem('userPreference', JSON.stringify(preference));
    // save preferencne
    const request$ = {
      lang: preference.language[0],
      timezone: preference.timezone[0],
      dateFormat: preference.dateFormat[0],
      currency: preference.currency[0],
      showsalary: preference.showsalary ? 1 : 0,
      whenshowcomment: preference.whenshowcomment ? 1 : 0,
      whenmovecand: preference.whenmovecand ? 1 : 0,
      showob: preference.showob ? 1 : 0,
      showdf: preference.showob ? 1 : 0,
      custom: JSON.stringify(preference.custom ?? {}),
    };

    this.preferenceService.update(request$).subscribe(_ => {});
  }

  getJobTemplates() {
    this._jobService.getJobTemplate().subscribe(data => {
      this.jobTemplates = data;

      // the subsriber has been created before
      // manually triggering subscriber of value changes to make it working on the 1st click
      this.templateInputCtrl.setValue('');
    });
  }

  filterTemplates(title: string) {
    const filterValue = title.toLowerCase();

    return this.jobTemplates.filter(template =>
      template.TemplateTitle.toLowerCase().includes(filterValue)
    );
  }

  templateDisplay(template): string {
    return template && template.TemplateTitle ? template.TemplateTitle.trim() : '';
  }

  /**
   * get the selected job template data
   * @param selectedTemplate
   */
  onTemplateSelected(selectedTemplate) {
    // const selectedTemplate = this.jobTemplates.find(template => template.JTemplateID == templateID);
    if (selectedTemplate) {
      this.defaults = selectedTemplate;

      // if (selectedTemplate.BUID) {
      //   this.getDepartments(selectedTemplate.BUID);
      // }

      this.setDeaprtmentBySelectedTemplate(selectedTemplate.BUID)

      /** Set key values */
      this.keyFormGroup.patchValue({
        jobTitle: selectedTemplate.TemplateTitle
          ? selectedTemplate.TemplateTitle.trim()
          : null,
        buisnessUnit: selectedTemplate.BUID ?? null,
        department:
          selectedTemplate.JTdepartment && selectedTemplate.JTdepartment != ''
            ? selectedTemplate.JTdepartment
            : selectedTemplate.Tdepid,
        jobDescription: selectedTemplate.TDescription,
        // requiredSkillExperience: this.defaults.TReqSkills ?? '',
        jobBenefit: selectedTemplate.JTbenefit ?? '',
      });

      this.keywords = selectedTemplate.Keyword ? selectedTemplate.Keyword.split(',') : [];

      /** Set location values */
      this.locationFormGroup.patchValue({
        locationCity: selectedTemplate.JTcity ?? '',
        locationZip: selectedTemplate.JTZip ?? '',
        locationAdditional: selectedTemplate.JTjoblocation ?? '',
      });

      if (this.countriesData.length > 0) {
        const country = this.countriesData.find(
          country => country.iso == selectedTemplate.JTcountry
        );
        if (country) {
          this.locationFormGroup.controls.locationCountry?.setValue(country.name);
          // this.getStates(country.name);
        } else {
          this.locationFormGroup.controls.locationCountry?.setValue('');

          // must clear states when the country is reset
          this.stateData = [];
          this.locationFormGroup.controls.locationState?.setValue('');
        }
      }

      const isHourlyApplyAvailable: boolean = this.isHourlyApplyAvailable();
      const defaultSalaryMin = isHourlyApplyAvailable ? 50 : 50000;
      const defaultSalaryMax = isHourlyApplyAvailable ? 100 : 60000;
      const salaryType = isHourlyApplyAvailable ? 'H' : '0';

      this.salaryFormGroup.patchValue({
        salary: '1',
        min: selectedTemplate.salary
          ? parseInt(this.defaults.salary.replace(/[^\d.-]/g, ''))
          : defaultSalaryMin,
        max: selectedTemplate.JTsalaryrange
          ? parseInt(this.defaults.JTsalaryrange.replace(/[^\d.-]/g, ''))
          : defaultSalaryMax,
        currency: selectedTemplate.JTsalarycurrency ?? 'USD',
        type:
          selectedTemplate.JTsaltype &&
          selectedTemplate.JTsaltype.trim() != '' &&
          this.freeSalaryTypes.includes(selectedTemplate.JTsaltype)
            ? selectedTemplate.JTsaltype
            : salaryType,
      });

      // if (this.salTypeData.length > 0) {
      //   const salaryType = (selectedTemplate.JTsaltype && selectedTemplate.selectedTemplate.JTsaltype.trim() != '') ? selectedTemplate.JTsaltype : '0';

      //   const found = this.salTypeData.find(type => type.RefValue === salaryType);
      //   if (found) {
      //     this.salaryFormGroup.controls.type?.setValue(found.RefValue);
      //   }
      // }

      // this.dateFormGroup.patchValue({
      //   internalCarrerHosting: null,
      //   chooseDate: null,
      //   startingDate: new Date()
      // });

      if (selectedTemplate.jobcatid) {
        this.getSubcategories(selectedTemplate.jobcatid);
      }

      this.optionalFormGroup.patchValue({
        jobCateogary: selectedTemplate.jobcatid ?? '',
        subCategory: selectedTemplate.JTcatID ?? '',
        eeoJobCateogray: selectedTemplate.JTeeoc_job_cat ?? '',
        startingDate: new Date(),
        status: '1',
        language: selectedTemplate.JTlanguage ? Number(selectedTemplate.JTlanguage) : 668,
        customJobId: '',
        jobLevel: selectedTemplate
          ? Number(selectedTemplate.JTjoblevel)
          : selectedTemplate.joblevel,
        noOfOpening: selectedTemplate.JTnumopening ?? 1,
        yearOfExperience: selectedTemplate.JTexpyears ?? '',
        levelOfEducation: selectedTemplate.JTdegree
          ? Number(selectedTemplate.JTdegree)
          : '',
        jobDuration: selectedTemplate.JTjobduration ?? '',
        travelFrequence:
          selectedTemplate.JTtravel && `${selectedTemplate.JTtravel}`.length == 1
            ? `00${selectedTemplate.JTtravel}`
            : `${selectedTemplate.JTtravel}`.length == 2
            ? `0${selectedTemplate.JTtravel}`
            : '0',
        internalCommentNotes: selectedTemplate.JTIntNotes ?? '',
        jobType: selectedTemplate.JTjobtype ?? 'Full Time',
        jobConfidential:
          selectedTemplate.JTtotalconfidential != null
            ? `${selectedTemplate.JTtotalconfidential}`
            : '0',
        jobPriority: selectedTemplate.JTpriority ? `${selectedTemplate.JTpriority}` : '1',
      });

      // reset form values ? don't required to reset as we don't have custom fields in the template
      /** when you enable template selection in update mode
       *  you can enable reset in only create mode
       */
      // comment this out if you want to reset form values entered before
      // this.customFormGroup.reset();

      this.userFormGroup.patchValue({
        hiringManager: null,
        // recruiter: null,
        owner: this.loginUserData.uid,
      });

      this.scorecardFormGroup.patchValue({
        scorecard: null,
      });

      this.templateFormGroup.patchValue({
        templateTitle: '',
      });

      /* 
      old examples
      this.defaults = item;
      this.keyword = this.defaults.Keyword != "" ? this.defaults.Keyword.split(',') : [];
      this.keywords = this.keyword;

      this.locationFormGroup.controls['locationCountry'].valueChanges.subscribe(value => {
        if (!value || value.trim().length == 0) {
          this.filteredCountriesData = this.countriesData;
          
        } else {
          this.filteredCountriesData = this.countriesData.filter(option => option.name.toLowerCase().includes(value.toLowerCase()));
          const country = this.countriesData.find(country => country.name.toLowerCase() == value.toLowerCase());
          if (country) {
            this.getState(country.iso);
          }
        }
      });

      this.locationFormGroup.controls['locationState'].valueChanges.subscribe(value => {
        this.filteredStateData = this.stateData.filter(option => option.name.toLowerCase().includes(value.toLowerCase()));
      });

      this.getCountries();
      this.getShiftData();
      this.getResourcesData();
      this.getPreQuestionsData();
      this.getPowerUsersData();

      if (this.defaults.BUID) {
        this.getDepartmentData(this.defaults.BUID);
      }
      */
    }
  }

  /**
   *
   * @param selected 1 - salary, 0 - competitive
   */
  onSalaryChanged(selected) {
    if (selected == '1') {
      // add validators
      this.salaryFormGroup.get('min').setValidators([Validators.required]);
      this.salaryFormGroup.controls['max'].setValidators([salaryValidator()]);

      this.salaryFormGroup.controls['min'].setValue(
        this.defaults.salary
          ? parseInt(this.defaults.salary.replace(/[^\d.-]/g, ''))
          : 50000
      );
      this.salaryFormGroup.controls['max'].setValue(
        this.defaults.salaryrange
          ? parseInt(this.defaults.salaryrange.replace(/[^\d.-]/g, ''))
          : this.defaults.JTsalaryrange
          ? parseInt(this.defaults.JTsalaryrange.replace(/[^\d.-]/g, ''))
          : 60000
      );
    } else {
      // reset validators
      this.salaryFormGroup.controls['min'].clearValidators();
      this.salaryFormGroup.controls['max'].clearValidators();

      this.salaryFormGroup.controls['min'].setValue('');
      this.salaryFormGroup.controls['max'].setValue('');
    }

    this.salaryFormGroup.controls['min'].updateValueAndValidity();
    this.salaryFormGroup.controls['max'].updateValueAndValidity();
  }

  next() {
    this.stepper.next();
  }

  getBusinessUnits() {
    this._departmentService.getBusinessUnitData().subscribe(data => {
      const businessUnits = data['data'];
      this.buisnessUnitData = businessUnits.filter(unit => unit.departments.length > 0);

      if (this.buisnessUnitData.length == 1 && this.isCreateMode()) {
        const defaultBusinessUnit = this.buisnessUnitData[0];
        this.keyFormGroup.controls.buisnessUnit?.setValue(defaultBusinessUnit.id);

        if (
          defaultBusinessUnit.departments &&
          defaultBusinessUnit.departments.length == 1
        ) {
          const defaultDepartment = defaultBusinessUnit.departments[0];
          this.keyFormGroup.controls.department?.setValue(defaultDepartment.deptid);

          this.departmentData = defaultBusinessUnit.departments;
        } else {
          this.getDepartments(defaultBusinessUnit.id);
        }
      }
    });
  }

  /**
   * get departments for the selected business unit
   * @param buid: business unit id
   */
  getDepartments(buid) {
    let departmentId;
    this._departmentService.getDepartment(buid).subscribe(response => {
      if (response['data'].length > 0) {
        this.departmentData = response['data'];        
      }
      if (this.departmentData.some(unit => unit.deptid === this.defaults.department)) {
        departmentId = this.defaults.department;
      } else {
        departmentId = this.departmentData[0].deptid;        
      }
      setTimeout(() => {
        this.keyFormGroup.controls.department.setValue(departmentId);
      }, 500);  
    });
  }

  setDeaprtmentBySelectedTemplate(buid) {
    let businessId;
    if (this.buisnessUnitData.some(unit => unit.id == buid)) {
      businessId = buid          
    } else {
      businessId = this.buisnessUnitData[0].id;      
    }
    this.getDepartments(businessId);
    setTimeout(() => {
      this.keyFormGroup.controls.buisnessUnit.setValue(businessId);
    }, 500);
    
  }

  locationDisplay(department): string {
    return [department.city, department.state].filter(item$ => item$).join(', ');
  }

  getDepartmentName(deptid): string {
    const department = this.departmentData.find(item => item.deptid == deptid);
    return department ? department.departmentName ?? '' : '';
  }

  /**
   *
   * @param catId
   * @param subcatID
   */
  getCateogires() {
    this._jobService.getJobCategory().subscribe(data => {
      this.jobCategoryData = data;

      // if (catId) {
      //   this.getSubcategories(catId);
      // }
    });
  }
  /**
   *
   * @param catId : category id
   * @returns
   */
  getSubcategories(catId) {
    const index = this.jobCategoryData.findIndex(category => category.cat_id == catId);

    if (index < 0) {
      return;
    }
    const majorId = this.jobCategoryData[index].major_id;
    this._jobService.getJobSubCategory(majorId).subscribe(data => {
      this.jobSubCategoryData = data;
      const subCategory = this.jobSubCategoryData.find(
        item => item.sub_id == this.optionalFormGroup.controls.subCategory.value
      );
      if (!subCategory) {
        this.optionalFormGroup.controls.subCategory.setValue('');
      }
    });
  }

  getEEOJobCategoryData() {
    this._jobService.getEEOJobCategoryData().subscribe(data => {
      this.eeoJobcategoryData = data;
    });
  }

  /**
   * use company location as job location
   * @returns
   */
  toggleAddress() {
    if (!this.companyData) {
      this.getCompanyInfo();
      return;
    }

    this.updateLocationWithCompanyAddress();
  }

  getCompanyInfo() {
    this._companyInfoService.getCompanyInfo().subscribe(data => {
      this.companyData = data;
      this.updateLocationWithCompanyAddress();
    });
  }

  updateLocationWithCompanyAddress() {
    this.locationFormGroup.patchValue({
      locationCity: this.companyData.city ?? '',
      locationCountry: this.companyData.country ?? '',
      locationState: this.companyData.state ?? '',
      locationZip: this.companyData.postalCode ?? '',
      locationAdditional: this.companyData.address1 ?? '',
    });
  }

  getCountries() {
    this._jobService.getCountriesData().subscribe(data => {
      var countries = data['data'];

      // sort by names in the ascending order
      countries.sort((lhs, rhs) =>
        lhs.name.toUpperCase() > rhs.name.toUpperCase() ? 1 : -1
      );

      // US first
      // check if US exists and remove it
      const indexOfUSA = countries.findIndex(country => country.iso == 'USA');
      if (indexOfUSA >= 0) {
        countries.splice(indexOfUSA, 1);
      }
      // add USA at the beginning of the array
      countries.unshift({ iso: 'USA', name: 'United States' });

      this.countriesData = countries;

      // passing through value changes
      // the priority should be form value, defaults and company location if it's required
      if (this.locationFormGroup.value.locationCountry) {
        // no actually required, can't set it previously by application steps
      } else if (this.defaults && Object.keys(this.defaults).length > 0) {
        const country = this.countriesData.find(
          country => country.iso == this.defaults.jobcountry || this.defaults.JTcountry
        );

        if (country) {
          this.locationFormGroup.controls['locationCountry'].setValue(country.name);
        } else {
          this.locationFormGroup.controls['locationCountry'].setValue('');

          // must clear states when the country is reset
          this.stateData = [];
          this.locationFormGroup.controls['locationState'].setValue('');
        }
      } else {
        // this.filteredCountriesData = data['data'];
        this.toggleAddress();
      }
    });
  }

  /**
   *
   * @param selected: country name
   */
  getStates(selected) {
    // always clear the last states before we get new
    this.stateData = [];

    const selectedCountry = this.countriesData.find(
      country => country.name.toLowerCase() === selected.toLowerCase()
    );
    if (selectedCountry) {
      this._jobService.getStateData(selectedCountry.iso).subscribe(res => {
        this.stateData = res.data;

        if (this.locationFormGroup.controls['locationState'].value) {
          // auto fill or use company location
          const stateValue =
            this.locationFormGroup.controls['locationState'].value.trim();
          this.filteredStateData = this.stateData.filter(state =>
            state.name.toLowerCase().includes(stateValue.toLowerCase())
          );

          const foundState = this.stateData.find(
            state => state.name.toLowerCase() == stateValue.toLowerCase()
          );
          if (!foundState) {
            this.locationFormGroup.controls.locationState?.setValue('');
          }
        } else if (this.defaults && Object.keys(this.defaults).length > 0) {
          const foundState = this.stateData.find(
            state => state.iso == this.defaults.jobstate || this.defaults.JTstate
          );

          if (foundState) {
            this.locationFormGroup.controls.locationState?.setValue(foundState.name);
          } else {
            this.locationFormGroup.controls.locationState?.setValue('');
          }
        } else {
          this.filteredStateData = this.stateData;
        }
      });
    }
  }

  /**
   * 5. Custom Fields
   * 0 - Text, 1 - Dropdown, 2 - Checkbox, 3 - Radio
   */
  getCustomFields() {
    this._jobService.getCustomFields().subscribe(res => {
      this.customFields = res.data;

      // an object array [{Fvalue: '123', CustID: 1504}, ...]
      const customFieldValues = this.defaults.cfvalue;

      this.customFields.forEach(customField => {
        const customFieldValue = customFieldValues
          ? customFieldValues.find(value => value.CustID == customField.customFieldID)
          : null;

        if (customField.customFieldType === 2) {
          this.customFormGroup.addControl(
            customField.customFieldID,
            this.fb.array(
              customField.selectFromValue.map(value =>
                customFieldValue ? customFieldValue.Fvalue.indexOf(value) > -1 : !1
              ),
              {
                validators: customField.customFieldRequired
                  ? this.requiredCheckboxValidator()
                  : null,
              }
            )
          );
        } else {
          customField.customFieldRequired
            ? this.customFormGroup.addControl(
                customField.customFieldID,
                new FormControl(
                  customFieldValue ? customFieldValue.Fvalue : '',
                  Validators.required
                )
              )
            : this.customFormGroup.addControl(
                customField.customFieldID,
                new FormControl(customFieldValue ? customFieldValue.Fvalue : '')
              );
        }
      });

      // this.cd.detectChanges();
    });
  }

  createCustomField() {
    this.dialog
      .open(JobListCreateUpdateComponent, {
        width: '100%',
      })
      .afterClosed()
      .subscribe(() => {
        this.getCustomFields();
      });
  }

  /**
   * 6. Users
   */

  /** 7. Questions */
  getPrescreenQuestions() {
    this._jobService.getPreQuestions().subscribe(res => {
      // filter out groups that don't have any questions
      const groups: any = res;
      this.jobQuestionGroups = groups.filter(group => group.questions.length > 0);

      this.jobQuestionGroups.map(group => {
        group.questions.map(question => {
          question['isSelected'] =
            (this.defaults.JobQ_num &&
              this.defaults.JobQ_num.includes(`${question.jobQ_ID}`)) ||
            (this.defaults.JTJobQ_num &&
              this.defaults.JTJobQ_num.includes(`${question.jobQ_ID}`));
        });

        group['isAllSelected'] = group.questions.every(question => question.isSelected);
      });

      // this.cd.detectChanges();
    });
  }

  onQuestionGroupSelected(selected: boolean, group): void {
    group.isAllSelected = selected;

    if (group.questions.length <= 0) {
      return;
    }
    group.questions.forEach(question => (question.isSelected = selected));
  }

  isQuestionSelectedInGroup(group): boolean {
    if (group.questions.length <= 0) {
      return false;
    }

    return (
      group.questions.filter(question => question.isSelected).length > 0 &&
      !group.isAllSelected
    );
  }

  /**
   * updating the group is selected or not
   * @param group the question group
   */
  onQuestionSelected(group) {
    group.isAllSelected =
      group.questions.length > 0 &&
      group.questions.every(question => question.isSelected);
  }

  addNewQuestion() {
    const dialogRef = this.dialog.open(AddNewQuestionComponent, {
      width: '100%',
      // data: previewData,
      height: '80%',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getPrescreenQuestions();
    });
  }

  /**
   * 8. Resources
   */
  getResourcesData() {
    this._jobService.getResources().subscribe(res => {
      this.resourcesData = res.data;

      this.addCheckboxes();
    });
  }

  private addCheckboxes() {
    this.resourcesData.forEach(resource =>
      this.ordersFormArray.push(
        new FormControl(
          (this.defaults.resources &&
            this.defaults.resources.includes(resource.mysite_id)) ||
            (this.defaults.JTonlinepost &&
              this.defaults.JTonlinepost.includes(resource.mysite_id))
        )
      )
    );
  }

  get ordersFormArray() {
    return this.resourceFormGroup.controls.resources as FormArray;
  }

  checkedResources(event, i) {
    if (event.checked === true) {
      // $scope.spn = true;
      if (this.Checkedval === '') {
        this.Checkedval = i;
      } else {
        this.Checkedval += ', ' + i;
      }
    }
  }

  // country autocomplete trigger panel is closed
  // clear input to only let the user select a country from the list
  public onCountryOptionPanelClosed() {
    const countries = this.countriesData.filter(
      country =>
        country.name.toLowerCase() ==
        this.locationFormGroup.value.locationCountry.toLowerCase()
    );
    if (countries.length <= 0) {
      this.locationFormGroup.controls.locationCountry.setValue('');
    } else {
      this.locationFormGroup.controls.locationCountry.setValue(countries[0].name);
    }
  }

  // state autocomplete selection closed
  // clear input to only let the user select a state from the list
  public onStateOptionPanelClosed() {
    const states = this.stateData.filter(
      state =>
        state.name.toLowerCase() ==
        this.locationFormGroup.value.locationState.toLowerCase()
    );

    if (states.length <= 0) {
      this.locationFormGroup.controls.locationState.setValue('');
    } else {
      this.locationFormGroup.controls.locationState.setValue(states[0].name);
    }
  }

  isCustomFieldValid(name: string) {
    if (this.customFormGroup.controls[name]) {
      return this.customFormGroup.controls[name].valid;
    } else {
      return null;
    }
  }

  isCheckCustomFieldValid(name: string) {
    if (this.customFormGroup.controls[name]) {
      return !this.customFormGroup.controls[name].errors?.[
        'requireOneCheckboxToBeChecked'
      ];
    } else {
      return null;
    }
  }

  isSaveEnabled() {
    if (this.isSimpleCreationEnabled) {
      return this.optionalFormGroup.valid;
    } else {
      return true;
    }
  }

  // job keyword
  addKeyword(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our keyword

    if ((value || '').trim()) {
      if (!this.keywords.includes(value.trim())) {
        this.keywords.push(value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.keyFormGroup.controls.jobKeyword.setValue(null);

    // this.fruitCtrl.setValue(null);
  }

  removeKeyword(keyword: string): void {
    const index = this.keywords.indexOf(keyword);
    if (index >= 0) {
      this.keywords.splice(index, 1);
    }
  }

  selectedKeyword(event: MatAutocompleteSelectedEvent): void {
    this.keywords.push(event.option.viewValue);
    this.keywordInput.nativeElement.value = '';
    this.keyFormGroup.controls.jobKeyword.setValue(null);
  }

  private _filterKeyword(value: string): string[] {
    const filterValue = value.toLowerCase();
    return window.allJobKeywords.filter(
      fruit => fruit.HotbookName.toLowerCase().indexOf(filterValue) === 0
    );
  }

  // All Stuff Related To Hiring Manager Start Here :---->>>
  addHiringManager(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if (input) {
      input.value = '';
    }

    this.userFormGroup.controls.hiringManager.setValue(null);
  }

  hiringManagerRemoved(removed): void {
    // The model is exactly same, so indexOf will work as it was in a string array
    const index = this.selectedHiringMangers.indexOf(removed);

    if (index >= 0) {
      this.selectedHiringMangers.splice(index, 1);
    }
  }

  // A new item has been selected from the autocomplete field
  hiringManagerSelected(event: MatAutocompleteSelectedEvent): void {
    const selected = this.allHiringManagers.find(item => item.uid == event.option.value);

    if (selected) {
      this.selectedHiringMangers.push(selected);
    }

    // to keep it working on the initial click
    this.userFormGroup.controls.hiringManager.disable();
    this.userFormGroup.controls.hiringManager.enable();

    this.hiringManagerInput.nativeElement.value = '';
    this.userFormGroup.controls.hiringManager.setValue(null);
  }

  private filterHiringManagers(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.allHiringManagers.filter(hiringManager =>
      hiringManager.userName.toLowerCase().includes(filterValue)
    );
  }

  // check and return if the hiring manager was already selected
  isHiringManagerSelected(item): boolean {
    return this.selectedHiringMangers.find(selected => selected.uid == item.uid) != null;
  }
  // All Stuff Related To Hiring Manager End

  // All Stuff Related To Recruiters Start Here :----->>>
  addRecruiter(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.userFormGroup.controls.recruiter.setValue(null);
  }

  recruiterRemoved(removed): void {
    const index = this.selectedRecruiters.indexOf(removed);

    if (index >= 0) {
      this.selectedRecruiters.splice(index, 1);
    }
  }

  recruiterSelected(event: MatAutocompleteSelectedEvent): void {
    const selected = this.allRecruiters.find(item => item.uid == event.option.value);

    if (selected) {
      this.selectedRecruiters.push(selected);
    }

    // to keep it working on the initial click
    this.userFormGroup.controls.recruiter.disable();
    this.userFormGroup.controls.recruiter.enable();

    this.recruiterInput.nativeElement.value = '';
    this.userFormGroup.controls.recruiter.setValue(null);
  }

  private filterRecruiters(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.allRecruiters.filter(recruiter =>
      recruiter.userName.toLowerCase().includes(filterValue)
    );
  }

  // check and return if the recruiter was already selected
  isRecruiterSelected(item): boolean {
    return this.selectedRecruiters.find(selected => selected.uid == item.uid) != null;
  }
  // All Stuff Related To Recruiters End

  // Job Creations Get endpoints start
  getYearOfExperienceData() {
    this._jobService.getyearofExperience().subscribe(data => {
      this.yearOfExperienceData = data;
    });
  }

  getPowerUsersData() {
    this._jobService.getPowerUsersData().subscribe(data => {
      this.powerUserData = data;

      const powerUser = this.powerUserData.find(
        item => item.uid == this.userFormGroup.controls.owner.value
      );
      if (!powerUser) {
        this.userFormGroup.controls.owner.setValue('');
      }
    });
  }

  getJobKeywordData() {
    this._jobService.getJobKeyword().subscribe(data => {
      this.jobKeywordData = data;
      window.jobKeywordData = data;
    });
  }

  getJobTypeData() {
    this._jobService.getJobTypeData().subscribe(data => {
      this.jobtypeData = data;
    });
  }

  getJobLevelData() {
    this._jobService.getJobLevelData().subscribe(data => {
      this.joblevelData = data;
    });
  }

  getEducationLevelData() {
    this._jobService.getEducationLevelData().subscribe(data => {
      this.educationLevelData = data;
    });
  }

  getLanaguageData() {
    this._jobService.getLanguageData().subscribe(data => {
      this.languageData = data;
      // setTimeout(() => {
      //   this.optionalFormGroup.controls['language'].setValue(this.defaults.joblanguage);
      // }, 4000)
    });
  }

  getShiftData() {
    this._jobService.getShift().subscribe(data => {
      this.shiftData = data;
      this.shiftData.map((item, i) => {
        this.optionalFormGroup.addControl(
          item.ShiftValue,
          new FormControl(
            (this.defaults.JobHours &&
              this.defaults.JobHours.includes(item.ShiftValue)) ||
              (this.defaults.JTjobhours &&
                this.defaults.JTjobhours.includes(item.ShiftValue))
          )
        );
      });
    });
  }

  getSalTypeData() {
    this._jobService.getSalType().subscribe(data => {
      const salaryTypes: any = data;

      this.salTypeData = salaryTypes.filter(type =>
        this.freeSalaryTypes.includes(type.RefValue)
      );
    });
  }

  getJobDurationData() {
    this._jobService.getJobDuration().subscribe(data => {
      this.jobDurationData = data;
    });
  }

  getJobTravelFrequencyData() {
    this._jobService.getJobTravelFrequency().subscribe(data => {
      this.jobTravelFrequencyData = data;
    });
  }

  getJobExpirationDateData() {
    this._jobService.getJobExpirationDate().subscribe(data => {
      this.jobExpirationDateData = data;
    });
  }

  getJobConfidentialData() {
    this._jobService.getJobConfidential().subscribe(data => {
      this.jobConfidentialData = data;
    });
  }

  getCostCenterData() {
    this._jobService.getCostCenter().subscribe(data => {
      this.jobCostCenterData = data;
    });
  }

  getJobCurrencyData() {
    this._jobService.getJobCurrency().subscribe(data => {
      this.jobCurrencyData = data;
    });
  }

  getAvailableScorecardData() {
    this._jobService.getAvailableScorecard().subscribe(data => {
      this.jobAvailableScorecardData = data;
    });
  }

  requiredCheckboxValidator(minRequired = 1): ValidatorFn {
    return function validate(formGroup: FormGroup) {
      let checked = 0;

      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.controls[key];

        if (control.value === true) {
          checked++;
        }
      });

      if (checked < minRequired) {
        return {
          required: true,
        };
      }

      return null;
    };
  }

  // Job Creations Get endpoints end
  openPreviewDialog() {
    let shiftValues = [];
    this.shiftData.map((item, i) => {
      this.optionalFormGroup.controls[item.ShiftValue].value
        ? shiftValues.push(item.ShiftName)
        : null;
    });

    const customData = [];
    let temp = [];
    this.customFields.forEach((x, i) => {
      const customFieldValue = this.customFormGroup.controls[x.customFieldID]
        ? this.customFormGroup.controls[x.customFieldID].value
        : null;
      if (customFieldValue) {
        if (x.customFieldType === 2) {
          const value = x.selectFromValue.filter((_, index) => customFieldValue[index]);
          temp.push({ name: x.customFieldName, value: value.join(',') });
        } else {
          temp.push({ name: x.customFieldName, value: customFieldValue });
        }
        if (temp.length == 2) {
          customData.push(temp);
          temp = [];
        }
      }
    });
    if (temp.length > 0) {
      customData.push(temp);
    }

    const owner = this.powerUserData.find(
      item => item.uid == this.userFormGroup.value.owner
    );

    const jobQ = [];
    this.jobQuestionGroups.map(list => {
      list.questions.map(question => {
        question.is_selected ? jobQ.push(question.Question) : null;
      });
    });

    let resources = '';
    if (this.resourceFormGroup.value) {
      const selectedOrderIds = this.resourceFormGroup.value.resources
        .map((checked, i) => (checked ? this.resourcesData[i].mysitename : null))
        .filter(v => v !== null);
      resources = selectedOrderIds.join(', ');
    }

    const country = this.countriesData.find(
      country =>
        country.name.toLowerCase() ==
        this.locationFormGroup.value.locationCountry.toLowerCase()
    );
    const state = this.stateData.find(
      state =>
        state.name.toLowerCase() ==
        this.locationFormGroup.value.locationState.toLowerCase()
    );
    const salCurrency = this.jobCurrencyData.find(
      item => item.CurrencyISO == this.salaryFormGroup.value.salCurrency
    );
    const salType = this.salTypeData.find(
      item => item.RefValue == this.salaryFormGroup.value.salType
    );
    const jobCateogary = this.jobCategoryData.find(
      item => item.cat_id == this.optionalFormGroup.value.jobCateogary
    );
    const subCategory = this.jobSubCategoryData.find(
      item => item.sub_id == this.optionalFormGroup.value.subCategory
    );
    const eeoJobCateogray = this.eeoJobcategoryData.find(
      item => item.eeoc_cat_id == this.optionalFormGroup.value.eeoJobCateogray
    );
    const jobType = this.jobtypeData.find(
      item => item.jobTypedesc == this.optionalFormGroup.value.jobType
    );
    const jobConfidential = this.jobConfidentialData.find(
      item => item.value == this.optionalFormGroup.value.jobConfidential
    );
    const language = this.languageData.find(
      item => item.LangID == this.optionalFormGroup.value.language
    );
    const jobLevel = this.joblevelData.find(
      item => item.LevelValue == this.optionalFormGroup.value.jobLevel
    );
    const yearOfExperience = this.yearOfExperienceData.find(
      item => item.YearExpValue == this.optionalFormGroup.value.yearOfExperience
    );
    const levelOfEducation = this.educationLevelData.find(
      item => item.DegreeOrder == this.optionalFormGroup.value.levelOfEducation
    );
    const jobDuration = this.jobDurationData.find(
      item => item.value == this.optionalFormGroup.value.jobDuration
    );
    const travelFrequence = this.jobTravelFrequencyData.find(
      item => item.value == this.optionalFormGroup.value.travelFrequence
    );
    const scorecard = this.jobAvailableScorecardData.find(
      item => item.SGID == this.scorecardFormGroup.value.scorecard
    );

    const previewData = [
      {
        step: 1,
        data: {
          buisnessUnit: this.buisnessUnitData.find(
            item => item.id == this.keyFormGroup.value.buisnessUnit
          ).name,
          department: this.departmentData.find(
            item => item.deptid == this.keyFormGroup.value.department
          ).departmentName,
          jobBenefit: this.keyFormGroup.value.jobBenefit,
          jobDescription: this.keyFormGroup.value.jobDescription,
          jobKeyword: this.keywords.join(',') || null,
          jobTitle: this.keyFormGroup.value.jobTitle,
          // requiredSkillExperience: this.keyFormGroup.value.requiredSkillExperience
        },
      },
      {
        step: 2,
        data: {
          locationCity: this.locationFormGroup.value.locationCity,
          locationCountry: country ? country.name : '',
          locationState: state ? state.name : '',
          locationZip: this.locationFormGroup.value.locationZip,
          locationAdditional: this.locationFormGroup.value.locationAdditional,
        },
      },
      {
        step: 3,
        data: {
          salaryMin: this.salaryFormGroup.value.salaryMin,
          salaryMax: this.salaryFormGroup.value.salaryMax,
          salCurrency: salCurrency ? salCurrency.CurrencyName : '',
          salType: salType ? salType.RefName : '',
        },
      },
      {
        step: 4,
        data: {
          jobCateogary: jobCateogary ? jobCateogary.catname : '',
          subCategory: subCategory ? subCategory.subcatname : '',
          eeoJobCateogray: eeoJobCateogray ? eeoJobCateogray.category : '',
          status: ['', 'Active', 'Inactive', 'Potential', 'Closed', 'Approved'][
            this.optionalFormGroup.value.status
          ],
          jobType: jobType ? jobType.jobTypedesc : '',
          noOfOpening: this.optionalFormGroup.value.noOfOpening,
          shift: shiftValues.join(', '),
          jobPriority: ['Low', 'Normal', 'High'][
            Number(this.optionalFormGroup.value.jobPriority)
          ],
          jobConfidential: jobConfidential ? jobConfidential.name : '',
          language: language ? language.LanguageName : '',
          jobLevel: jobLevel ? jobLevel.LevelName : '',
          customJobId: this.optionalFormGroup.value.customJobId,
          yearOfExperience: yearOfExperience ? yearOfExperience.YearExp : '',
          levelOfEducation: levelOfEducation ? levelOfEducation.DegreeName : '',
          jobDuration: jobDuration ? jobDuration.name : '',
          travelFrequence: travelFrequence ? travelFrequence.name : '',
          internalCommentNotes: this.optionalFormGroup.value.internalCommentNotes,
        },
      },
      {
        step: 5,
        data: {
          customData: customData,
        },
      },
      {
        step: 6,
        data: {
          hiringManager: this.selectedHiringMangers.map(item => item.userName).join(', '),
          recruiters: this.selectedRecruiters.map(item => item.userName).join(', '),
          owner: `${owner.firstname} ${owner.lastname}`,
        },
      },
      {
        step: 7,
        data: {
          jobQ: jobQ,
        },
      },
      {
        step: 8,
        data: {
          resources: resources,
        },
      },
      {
        step: 9,
        data: {
          scorecard: scorecard ? scorecard.GroupName : '',
        },
      },
    ];

    const dialogRef = this.dialog.open(PreviewContentDialog, {
      width: '100%',
      height: '90%',
      data: previewData,
      // height: '800px'
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  isCreateMode() {
    return this.mode === 'create';
  }

  isUpdateMode() {
    return this.mode === 'update';
  }

  /**
   * Form submit
   */
  save() {
    if (this.mode === 'create') {
      this.createCustomer();
    } else if (this.mode === 'update') {
      this.updateCustomer();
    }
  }

  createCustomer() {
    if (this.keyFormGroup.invalid || this.locationFormGroup.invalid) {
      return false;
    }

    let resources;
    if (this.resourceFormGroup.value) {
      const selectedOrderIds = this.resourceFormGroup.value.resources
        .map((checked, i) => (checked ? this.resourcesData[i].mysite_id : null))
        .filter(v => v !== null);
      resources = selectedOrderIds.join();
    }

    let shiftValues = [];
    this.shiftData.map((item, i) => {
      this.optionalFormGroup.controls[item.ShiftValue].value
        ? shiftValues.push(item.ShiftValue)
        : null;
    });

    const customData = {
      customID: '',
      custID_noFvalue: '',
    };
    // const existingCustIDs = this.defaults.cfvalue ? this.defaults.cfvalue.map(value => value.CustID) : null;
    // existingCustIDs ?
    this.customFields.forEach((x, i) => {
      if (this.customFormGroup.controls[x.customFieldID].value) {
        customData.customID =
          customData.customID +
          (customData.customID.length == 0 ? '' : ',') +
          x.customFieldID;
        // existingCustIDs.includes(x.customFieldID) ? null : customData.custID_noFvalue = customData.custID_noFvalue + (customData.custID_noFvalue.length == 0 ? '' : ',') + x.customFieldID;
        if (x.customFieldType === 2) {
          const values = [];
          var custom = '';
          this.customFormGroup.controls[x.customFieldID].value.forEach((element, j) => {
            element ? values.push(x.selectFromValue[j]) : null;
          });
          values.forEach((value, k) => {
            custom = custom + (k == 0 ? '' : ',') + value;
          });
          customData[`cfvalue_${x.customFieldID}`] = custom;
        } else {
          customData[`cfvalue_${x.customFieldID}`] =
            this.customFormGroup.controls[x.customFieldID].value;
        }
      }
    });

    const country = this.countriesData.filter(
      country =>
        country.name.toLowerCase() ==
        this.locationFormGroup.value.locationCountry.toLowerCase()
    );
    const state = this.stateData.filter(
      state =>
        state.name.toLowerCase() ==
        this.locationFormGroup.value.locationState.toLowerCase()
    );

    if (country.length <= 0 || state.length <= 0) {
      return;
    }

    const hmjobs = this.selectedHiringMangers.map(item => item.uid);

    const rtjobs = this.selectedRecruiters.map(item => item.uid);

    let jobQ = [];
    this.jobQuestionGroups.forEach(group => {
      group.questions.forEach(question => {
        if (question.isSelected) {
          jobQ.push(question.jobQ_ID);
        }
      });
    });

    const createJob$ = {
      expiredate: '', // this.dateFormGroup.value.internalCarrerHosting,
      trackingcode: this.optionalFormGroup.value.customJobId,
      resources: resources,
      job_title: this.keyFormGroup.value.jobTitle,
      jobdescription: this.keyFormGroup.value.jobDescription,
      numopening: this.optionalFormGroup.value.noOfOpening,
      jobtype: this.optionalFormGroup.value.jobType,
      /** salary form values */
      salary:
        this.salaryFormGroup.value.salary === '1' ? this.salaryFormGroup.value.min : 0,
      salmax:
        this.salaryFormGroup.value.salary === '1' ? this.salaryFormGroup.value.max : 0,
      salcurrency: this.salaryFormGroup.value.currency,
      saltype: this.salaryFormGroup.value.type,

      priority: this.optionalFormGroup.value.jobPriority,
      aflag: this.optionalFormGroup.value.status,
      duration: this.optionalFormGroup.value.jobDuration,
      eeoccat: this.optionalFormGroup.value.eeoJobCateogray,
      jobcat: this.optionalFormGroup.value.subCategory,
      department: this.keyFormGroup.value.department,
      zip: this.locationFormGroup.value.locationZip,
      country: country[0].iso,
      state: state[0].iso,
      locations: (this.locationFormGroup.value.locations || []).join(','),
      City: this.locationFormGroup.value.locationCity,
      joblev: this.optionalFormGroup.value.jobLevel,
      reqsexp: this.keyFormGroup.value.jobDescription, // this.keyFormGroup.value.requiredSkillExperience,
      experyrs: this.optionalFormGroup.value.yearOfExperience,
      degree: this.optionalFormGroup.value.levelOfEducation,
      travel: this.optionalFormGroup.value.travelFrequence,
      start: this.optionalFormGroup.value.startingDate ? moment(this.optionalFormGroup.value.startingDate).format('YYYY-MM-DD') : null,
      intnotes: this.optionalFormGroup.value.internalCommentNotes,
      hmjobs: hmjobs.join(','),
      rtjobs: rtjobs.join(','),
      // "onlineposting": "2",
      jobQ: jobQ.join(','),
      jobkeyword: this.keywords.join(),
      // "mscity": "",
      jobbenefits: this.keyFormGroup.value.jobBenefit,
      language: this.optionalFormGroup.value.language,
      joblocationstr: this.locationFormGroup.value.locationAdditional,
      Jobhours: shiftValues.join(','),
      // "jobdispencode": "1",
      jobconfidential: this.optionalFormGroup.value.jobConfidential,
      // "IskilljobQ": "1,2,3",
      // "fee_type": "1",
      // "fee_amount": "100",
      jobowner: this.isSimpleCreationEnabled
        ? this.loginUserData.uid
        : this.userFormGroup.value.owner,
      sgid: this.scorecardFormGroup.value.scorecard ?? '',
      template_title: this.templateFormGroup.value.templateTitle,
      ...customData,
    };

    this._backgroundService.showLoading();
    this._jobService.postJobCreation(createJob$).subscribe(
      data => {
        this._backgroundService.hideLoading();

        if (data['message'] === 'Success') {
          const currentJobsCount = +localStorage.getItem(PreferenceKeys.TotalJobsCount);
          localStorage.setItem(
            PreferenceKeys.TotalJobsCount,
            (currentJobsCount + 1).toString()
          );

          this.showWarning(
            this.translate.instant('JOB_LOCKDOWN_7_DAYS'),
            this.translate.instant('OK'),
            SnackBarDuration.INFINITE
          );
          // this.showSuccess(this.translate.instant('JOB_POSTED_SUCCESSFULLY'));
          this.dialogRef.close(createJob$);
        } else {
          this.showError(this.translate.instant('JOB_POST_FAILED_TRY_AGAIN'));
        }
      },
      () => {
        this._backgroundService.hideLoading();
        this.showError(this.translate.instant('JOB_POST_FAILED_TRY_AGAIN'));
      }
    );
  }

  updateCustomer() {
    let resources;
    if (this.resourceFormGroup.value) {
      const selectedOrderIds = this.resourceFormGroup.value.resources
        .map((checked, i) => (checked ? this.resourcesData[i].mysite_id : null))
        .filter(v => v !== null);
      resources = selectedOrderIds.join();
    }

    let shiftValues = [];
    this.shiftData.map((item, i) => {
      this.optionalFormGroup.controls[item.ShiftValue].value
        ? shiftValues.push(item.ShiftValue)
        : null;
    });

    const customData = {
      customID: '',
      custID_noFvalue: '',
    };
    const existingCustIDs = this.defaults.cfvalue.map(value => value.CustID);
    this.customFields.forEach((x, i) => {
      if (this.customFormGroup.controls[x.customFieldID].value) {
        customData.customID =
          customData.customID +
          (customData.customID.length == 0 ? '' : ',') +
          x.customFieldID;
        existingCustIDs.includes(x.customFieldID)
          ? null
          : (customData.custID_noFvalue =
              customData.custID_noFvalue +
              (customData.custID_noFvalue.length == 0 ? '' : ',') +
              x.customFieldID);
        if (x.customFieldType === 2) {
          const values = [];
          var custom = '';
          this.customFormGroup.controls[x.customFieldID].value.forEach((element, j) => {
            element ? values.push(x.selectFromValue[j]) : null;
          });
          values.forEach((value, k) => {
            custom = custom + (k == 0 ? '' : ',') + value;
          });
          customData[`cfvalue_${x.customFieldID}`] = custom;
        } else {
          customData[`cfvalue_${x.customFieldID}`] =
            this.customFormGroup.controls[x.customFieldID].value;
        }
      }
    });

    const hmjobs = this.selectedHiringMangers.map(item => item.uid);

    const rtjobs = this.selectedRecruiters.map(item => item.uid);

    let jobQ = [];
    this.jobQuestionGroups.forEach(group => {
      group.questions.forEach(question => {
        if (question.isSelected) {
          jobQ.push(question.jobQ_ID);
        }
      });
    });

    const country = this.countriesData.filter(
      country =>
        country.name.toLowerCase() ==
        this.locationFormGroup.value.locationCountry.toLowerCase()
    );
    const state = this.stateData.filter(
      state =>
        state.name.toLowerCase() ==
        this.locationFormGroup.value.locationState.toLowerCase()
    );

    if (country.length <= 0 || state.length <= 0) {
      return;
    }

    const updateJob$ = {
      jid: this.defaults.jid,
      expiredate: '', // this.dateFormGroup.value.internalCarrerHosting,
      trackingcode: this.optionalFormGroup.value.customJobId,
      resources: resources,
      job_title: this.keyFormGroup.value.jobTitle,
      jobdescription: this.keyFormGroup.value.jobDescription,
      numopening: this.optionalFormGroup.value.noOfOpening,
      jobtype: this.optionalFormGroup.value.jobType,

      /** salary form values */
      salary:
        this.salaryFormGroup.value.salary === '1' ? this.salaryFormGroup.value.min : 0,
      salmax:
        this.salaryFormGroup.value.salary === '1' ? this.salaryFormGroup.value.max : 0,
      salcurrency: this.salaryFormGroup.value.currency,
      saltype: this.salaryFormGroup.value.type,

      priority: this.optionalFormGroup.value.jobPriority,
      aflag: this.optionalFormGroup.value.status,
      duration: this.optionalFormGroup.value.jobDuration,
      eeoccat: this.optionalFormGroup.value.eeoJobCateogray,
      jobcat: this.optionalFormGroup.value.subCategory,
      department: this.keyFormGroup.value.department,
      zip: this.locationFormGroup.value.locationZip,
      country: country[0].iso,
      state: state[0].iso,
      locations: (this.locationFormGroup.value.locations || []).join(','),
      City: this.locationFormGroup.value.locationCity,
      joblev: this.optionalFormGroup.value.jobLevel,
      reqsexp: this.keyFormGroup.value.jobDescription, //this.keyFormGroup.value.requiredSkillExperience,
      experyrs: this.optionalFormGroup.value.yearOfExperience,
      degree: this.optionalFormGroup.value.levelOfEducation,
      travel: this.optionalFormGroup.value.travelFrequence,
      start: this.optionalFormGroup.value.startingDate ? moment(this.optionalFormGroup.value.startingDate).format('YYYY-MM-DD') : null,
      intnotes: this.optionalFormGroup.value.internalCommentNotes,
      hmjobs: hmjobs.join(','),
      rtjobs: rtjobs.join(','),
      jobQ: jobQ.join(','),
      jobkeyword: this.keywords.join(),
      STATUS: 1,
      // "mscity": "",
      jobbenefits: this.keyFormGroup.value.jobBenefit,
      language: this.optionalFormGroup.value.language,
      joblocationstr: this.locationFormGroup.value.locationAdditional,
      Jobhours: shiftValues.join(','),
      // "jobdispencode": "1",
      jobconfidential: this.optionalFormGroup.value.jobConfidential,
      // "IskilljobQ": "1,2,3",
      // "fee_type": "1",
      // "fee_amount": "100",
      // "jobadmin": 323452,
      // "question": "question",
      jobowner: this.isSimpleCreationEnabled
        ? this.loginUserData.uid
        : this.userFormGroup.value.owner,
      sgid: this.scorecardFormGroup.value.scorecard ?? '',
      template_title: this.templateFormGroup.value.templateTitle,
      ...customData,
    };

    this._backgroundService.showLoading();
    this._jobService.updateJobCreation(updateJob$).subscribe(
      data => {
        this._backgroundService.hideLoading();

        if (data['message'] === 'Success') {
          this.showSuccess(this.translate.instant('JOB_UPDATED_SUCCESSFULLY'));
          this.dialogRef.close(updateJob$);
        } else {
          this.showError(this.translate.instant('JOB_UPDATE_FAILED_TRY_AGAIN'));
        }
      },
      err => {
        this._backgroundService.hideLoading();

        this.showError(this.translate.instant('JOB_UPDATE_FAILED_TRY_AGAIN'));
      }
    );
  }

  isHourlyApplyAvailable(): boolean {
    const applyType = localStorage.getItem(PreferenceKeys.ApplyType);
    return applyType == 'readyatshourly';
  }
}

function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => (next ? prev + next : prev), 0);

    return totalSelected >= min ? null : { required: true };
  };
  return validator;
}

@Component({
  selector: 'preview-content-dialog',
  templateUrl: 'preview-content-dialog.html',
  styles: [
    `
      .my-btn {
        width: 30px;
        height: 30px;
        line-height: 14px;
        font-size: 14px;
        margin-top: 5px;
      }
      ::ng-deep .mat-mini-fab .mat-button-wrapper {
        line-height: 10px !important;
      }
      .mat-dialog-content {
        max-height: calc(100vh - 220px) !important;
      }
    `,
  ],
  animations: [fadeInUp400ms, fadeInRight400ms, scaleIn400ms, stagger40ms],
})
export class PreviewContentDialog implements OnInit {
  isReadMoreJobDescription: Boolean = true;
  isReadMoreRequireSkillExp: Boolean = true;
  isReadMoreJobBenefits: Boolean = true;

  isSimpleCreationEnabled: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private envService: EnvironmentService
  ) {}

  ngOnInit() {
    const membership$ = +localStorage.getItem('membership');

    /**
     * load configuration based on membership
     * configuration is always preferred
     * 1. free users: default true
     * 2. paid users: default false
     */
    if (membership$ > 0) {
      // load the configuration
      const simpleJobCreationEnabled$ =
        this.envService.getConfig('simpleJobCreationEnabled').paid ?? false;

      // check for user preference
      let preference = JSON.parse(localStorage.getItem('userPreference'));
      if (preference.custom) {
        // user preference or configuration
        this.isSimpleCreationEnabled =
          preference.custom.simpleJobCreationEnabled ?? simpleJobCreationEnabled$;
      }
    } else {
      // simple job creation default 'true' for free users
      // load the configuration
      this.isSimpleCreationEnabled =
        this.envService.getConfig('simpleJobCreationEnabled').free ?? true;
    }
  }
}

function salaryValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || !control.value) {
      return null;
    }

    return !!control.parent &&
      !!control.parent.value &&
      Number(control.value) < Number((control.parent?.controls as any)['min'].value)
      ? { wrongSalary: true }
      : null;
  };
}
